import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function BookIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.29562 4.15331C4.4819 4.01146 4.72374 3.96475 4.94945 4.02701L12 5.97199L19.0506 4.02701C19.2763 3.96475 19.5181 4.01146 19.7044 4.15331C19.8907 4.29516 20 4.51587 20 4.75001V17.25C20 17.5874 19.7747 17.8833 19.4494 17.973L12.1994 19.973C12.0689 20.009 11.9311 20.009 11.8006 19.973L4.55055 17.973C4.2253 17.8833 4 17.5874 4 17.25V4.75001C4 4.51587 4.10935 4.29516 4.29562 4.15331ZM11.25 7.32112L5.5 5.73492V16.6789L11.25 18.2651V7.32112ZM12.75 18.2651L18.5 16.6789V5.73492L12.75 7.32112V18.2651Z"
        fill="currentColor"
      />
    </svg>
  );
};
